import { render, staticRenderFns } from "./CardMaquina.vue?vue&type=template&id=fc1d2086&scoped=true&"
import script from "./CardMaquina.vue?vue&type=script&lang=js&"
export * from "./CardMaquina.vue?vue&type=script&lang=js&"
import style0 from "./CardMaquina.vue?vue&type=style&index=0&id=fc1d2086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1d2086",
  null
  
)

export default component.exports